import React from 'react'
import cs from 'classnames'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import pixel from '../../../assets/Pixel1.png'
import pixelFr from '../../../assets/Pixel1_FR.png'
import intlMessagesApp from 'src/modules/App/translations'
import SvgIcon from 'src/components/SvgIcon'

import commonStyles from '../../common.module.less'

import styles from './styles.module.less'

import toReactComponent from 'svgr.macro'

const Gear = toReactComponent('../../../assets/GearIcon.svg')
const TapIconDown = toReactComponent('../../../assets/TapIconDown.svg')
const Tooltip = toReactComponent('../../../assets/TapIconDown.svg')

const AndroidStep1 = props => {
  const screenshot = props.language === 'fr' ? pixelFr : pixel
  return (
    <section className={cs(commonStyles.container)}>
      <section className={commonStyles.top}>
        <TapIconDown className={styles.iconDownStep} />
        <Tooltip className={styles.tooltip} />
        <img
          src={screenshot}
          className={styles.bgStep}
          alt={props.intl.formatMessage(intlMessagesApp.altScreenshot)}
        />
        <div className={styles.overlayStep} />
        <div className={styles.tooltipText}>
          <FormattedMessage
            id='app.lock.android.screen1.tooltip.protectYourData'
            defaultMessage='To protect your data, make sure this toggle is also enabled.'
          />
        </div>
      </section>
      <section className={commonStyles.bottom}>
        <div className={commonStyles.content}>
          <header>
            <SvgIcon
              className={commonStyles.iconFabStep}
              size='xlg'
              type='LockIcon'
              style={{ margin: '5px auto' }}
            />
            <h2>
              <FormattedMessage id='app.lock.header.privacy' defaultMessage='Privacy' />
            </h2>
            <p>
              <FormattedMessage
                id='app.lock.header.privacy.description'
                defaultMessage='Turn on Screen Sharing'
              />
            </p>
          </header>
          <div className={commonStyles.scrollable}>
            <div className={styles.description}>
              <p className={styles.inlineParagraf}>
                <FormattedMessage
                  id='app.lock.android.screen1.p1'
                  defaultMessage="Open your device's Settings app"
                />
              </p>
              <Gear />
            </div>
            <div className={commonStyles.line} style={{ marginTop: 0 }} />
            <p>
              <FormattedMessage
                id='app.lock.android.screen1.p2'
                defaultMessage='Tap Security & Location > Advanced > Screen Pinning.'
              />
            </p>
            <div className={commonStyles.line} />
            <p>
              <FormattedHTMLMessage
                id='app.lock.android.screen1.p3'
                defaultMessage='Turn on <b>Screen Pinning.</b>'
              />
            </p>
          </div>
        </div>
      </section>
    </section>
  )
}

export default injectIntl(AndroidStep1)
